import { BOOKINGS_APP_DEF_ID } from '@wix/bookings-catalog-calendar-viewer-utils';
import { getPricingPlansPublicAPI } from '@wix/pricing-plans-tpa-api';
const getPricingPlansApi = async wixCodeApi => {
  if (!getPricingPlansApi.pricingPlansApi) {
    getPricingPlansApi.pricingPlansApi = await getPricingPlansPublicAPI(wixCodeApi);
  }
  return getPricingPlansApi.pricingPlansApi;
};
export async function navigateToPricingPlan(_ref) {
  let {
    wixCodeApi,
    redirectTo,
    planIds,
    maxStartDate,
    queryParams,
    title,
    subtitle
  } = _ref;
  const api = await getPricingPlansApi(wixCodeApi);
  return api.navigateToPackagePicker({
    planIds,
    title,
    subtitle,
    checkout: {
      maxStartDate,
      successStatus: {
        navigation: {
          type: 'section',
          options: {
            appDefinitionId: BOOKINGS_APP_DEF_ID,
            sectionId: redirectTo.sectionId,
            state: redirectTo.relativePath,
            queryParams
          }
        }
      }
    }
  });
}
export async function navigateToPricingPlanPreview(_ref2) {
  let {
    wixCodeApi,
    title,
    subtitle
  } = _ref2;
  const api = await getPricingPlansApi(wixCodeApi);
  return api.navigateToPackagePicker({
    title,
    subtitle
  });
}
//# sourceMappingURL=navigateToPricingPlan.js.map